import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import ExerciseSlidePanel from '../exercise-slide-panel/ExerciseSlidePanel';
import { useStyles } from './ExercisesListWithPanel.styles';
import theme from '../../../styles/theme';

export type ExercisePanelMode = 'view' | 'edit' | 'new';

interface ExercisesListWithPanelProps {
  listContent: ReactNode;
  panelContent: ReactNode | null;
  panelOpen: boolean;
  onPanelClose: () => void;
}

export default function ExercisesListWithPanel({
  listContent,
  panelContent,
  panelOpen,
  onPanelClose,
}: ExercisesListWithPanelProps) {
  const { classes } = useStyles(theme);

  return (
    <Box className={classes.root}>
      <Box
        className={`${classes.listSection} ${
          panelOpen ? classes.listSectionWithPanel : ''
        }`}>
        {listContent}
      </Box>
      <ExerciseSlidePanel open={panelOpen} onClose={onPanelClose}>
        {panelContent}
      </ExerciseSlidePanel>
    </Box>
  );
}
